import React from "react";
import get from "lodash/get";
import { object, bool, string, number, node } from "prop-types";

import Contributor from "../../atoms/Contributor";
import ContributorImage from "../../atoms/ContributorImage";

import "./authorDetails.m.css";

const AuthorDetails = ({
  story,
  authorObj,
  authorName,
  withAvatar = true,
  slug,
  contributorType = 4,
  role = "",
  className = "",
  authorDetailsType = ""
}) => {
  const authorDisplayName = get(story, ["metadata", "story-attributes", "author-display-name", "0"], null);
  return (
    <div styleName="base" className={`author-details-wrapper ${className}`} data-testid="story-author">
      <div className="author-details" styleName={authorDetailsType}>
        {withAvatar && !authorDisplayName && <ContributorImage authorObj={authorObj} slug={slug} />}
        {withAvatar && authorDisplayName && (
          <ContributorImage authorDisplayName={authorDisplayName} authorObj={authorObj} slug={slug} />
        )}
        <Contributor
          name={authorName}
          role={role}
          contributorType={contributorType}
          slug={slug}
          authorObj={authorObj}
          authorDisplayName={authorDisplayName}
        />
      </div>
    </div>
  );
};

AuthorDetails.propTypes = {
  story: object,
  authorObj: object.isRequired,
  withAvatar: bool,
  slug: string,
  contributorType: number,
  role: string,
  className: string,
  authorName: node,
  authorDetailsType: string
};

export default AuthorDetails;
